






































import Vue from 'vue';
import Sticky from '@/vue-components/util/Sticky.vue';
import CardHeader from '@/vue-components/util/CardHeader.vue';

export default Vue.extend({
  name: 'Feedback',
  components: {
    Sticky,
    CardHeader,
  }
});
